import React from 'react';
import { bonuses } from '../data/content';
import { BONUS_SIZES, BONUS_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { Accent, SectionHeading } from './SectionHeading';
export function BonusesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 pt-4 sm:pb-16" aria-labelledby="bonos-titulo" data-id="element-1" data-mp="vuh67y7c4gem">
      <div className="mx-auto max-w-4xl" data-id="element-2" data-mp="qsi22m3rtfgm">
        <SectionHeading id="bonos-titulo" title={<>
              5 Bonos Estratégicos <Accent data-id="element-4" data-mp="14r8147a5hp7m">Siempre Incluidos</Accent>
            </>} subtitle="Siempre incluidos, siempre gratis: implementación, clases listas, terminología, checklists y casos reales." data-id="element-3" data-mp="14tb1nl8xj0ql" />

        <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-5" data-mp="1eim3cmthl34g">
          {bonuses.map(({
          number,
          title,
          description,
          image
        }) => <li key={number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-cream-300/70 bg-cream-50 p-4" data-id="element-6" data-mp="1njahdhivr3hc">
              <div className="relative overflow-hidden rounded-xl" data-id="element-7" data-mp="1jkbhibc09wwr">
                <img src={optimizedImage(image, 420)} srcSet={optimizedSrcSet(image, BONUS_WIDTHS)} sizes={BONUS_SIZES} alt={`Portada del bono ${number}: ${title}`} width={1200} height={900} loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-8" data-mp="3prdcs4jlqrug" />
                <span className="absolute left-3 top-3 rounded-md bg-ember-500 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-white" data-id="element-9" data-mp="7kfkszyt0dnb">
                  Bono {number}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-forest-700 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-ember-400" data-id="element-10" data-mp="gkvi1royeojq">
                  Gratis
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold leading-snug text-forest-800" data-id="element-11" data-mp="q9vlpoeei849">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-forest-700/85" data-id="element-12" data-mp="vburf4xm5h4d">{description}</p>
            </li>)}

          <li className="flex h-full flex-col items-center justify-center rounded-2xl bg-forest-700 p-8 text-center" data-id="element-13" data-mp="109mftoz1ul3t">
            <p className="font-display text-2xl font-semibold leading-snug text-cream-50" data-id="element-14" data-mp="aiw5unixzr2b">
              Valor total de bonos  <span className="text-ember-400" style={{
              fontSize: "28px"
            }} data-id="element-15" data-mp="kas7g8k8lzba">$70 USD</span>
            </p>
            <p className="mt-3 text-sm text-cream-100/75" data-id="element-16" data-mp="fjag8c80nd3i">GRATIS con tu Kit.</p>
          </li>
        </ul>
      </div>
    </section>;
}